import type { AppContext } from 'types/common'
import component from './BreakEven.svelte'
import { graphql } from '$houdini'

export default ({ mediator, stateRouter }: AppContext) => {
	stateRouter.addState({
		name: 'app.vehicle.break-even',
		route: 'break-even',
		template: { component, svelte: true },
		async resolve(_data, parameters) {
			const { data } = await query.fetch({
				variables: {
					vehicleId: parseInt(parameters.vehicleId, 10) ?? undefined,
				},
			})

			const seriesTitles: Array<string | number | Date | null> = ['Date', 'Cost', 'Cost of Goods Sold', 'Sales']

			const chartData = [seriesTitles].concat(
				(data?.vehicle?.reportData?.breakEven ?? []).reduce(
					(acc: Array<Array<string | number | Date | null>>, item, index) => {
						const lastExpenses = index > 0 ? Number(acc[index - 1][1]) || 0 : 0
						const lastCogs = index > 0 ? Number(acc[index - 1][2]) || 0 : 0
						const lastSales = index > 0 ? Number(acc[index - 1][3]) || 0 : 0

						acc.push([
							new Date(item.date),
							item.expensesTotal ? Number(item.expensesTotal) + lastExpenses : lastExpenses,
							item.costOfGoodsSoldTotal ? Number(item.costOfGoodsSoldTotal) + lastCogs : lastCogs,
							item.salesTotal ? Number(item.salesTotal) + lastSales : lastSales,
						])
						return acc
					},
					[],
				),
			)

			return {
				//
				chartData,
			}
		},
	})
}

const query = graphql(`
	query VehicleBreakEvenReportData($vehicleId: Int!) {
		vehicle(id: $vehicleId) {
			reportData {
				breakEven {
					date
					expensesCount
					# Cost?
					expensesTotal
					salesCount
					# Sales
					salesTotal
					costOfGoodsSoldTotal
				}
			}
		}
	}
`)
